import { otpDelivery } from "../../OptionalFeatures/SecureEcommerceACS";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { toTitleCase } from "../../../../Utils/stringUtls";

const ECommerceOverview = ({ data }) => {
  const {
    of_acs_enable_acs,
    of_acs_acs_provider,
    of_acs_provider_other,
    of_acs_otp_services = [],
    of_acs_otp_service_other,
    of_acs_otp_service_provider,
    of_acs_otp_service_provider_other,
  } = data["2_3"];

  const otpDeliveryValue = of_acs_otp_services?.length
    ? otpDelivery
        .filter((source) => of_acs_otp_services.includes(source.value))
        .map((source) =>
          source.value === "other" ? of_acs_otp_service_other : source.label
        )
        .join(", ")
    : null;

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid" className="review-summary-gap">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <ReviewSummarySectionHeading title="3D Secure Transactions " />
        </div>

        <ReviewAttribute
          label="Enable ACS"
          value={of_acs_enable_acs?.length ? toTitleCase(of_acs_enable_acs) : null}
        />

        {of_acs_enable_acs === "yes" ? (
          <>
            <ReviewAttribute
              label="ACS Service Provider"
              value={
                of_acs_acs_provider?.length
                  ? of_acs_acs_provider === "other"
                    ? `Other (${of_acs_provider_other})`
                    : of_acs_acs_provider
                  : null
              }
            />
          </>
        ) : null}

        <ReviewAttribute
          label="Who will deliver OTP to the cardholder"
          value={
            of_acs_otp_service_provider?.length
              ? of_acs_otp_service_provider === "other"
                ? `Other (${of_acs_otp_service_provider_other})`
                : of_acs_otp_service_provider
              : null
          }
        />
        <ReviewAttribute
          label="How would you like the OTP to be delivered to cardholders"
          value={otpDeliveryValue}
        />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default ECommerceOverview;
